import React, { Component } from 'react';
import PropTypes, { bool } from 'prop-types';
import classnames from 'classnames';

import { findItem } from 'Components/forms/select-input';
import GDFilterElement from 'Components/GDReportRunner/GDFilterElement';
import PrimaryButton from 'Components/Button/PrimaryButton';
import Button from 'Components/Button/Button';
import TriangleDown from 'Components/icons/TriangleDown/TriangleDown';
import TriangleUp from 'Components/icons/TriangleUp/TriangleUp';

import * as types from 'Utils/alertKeys';
import { normalizeDateFilters } from 'Utils/reports/reportFilterUtils';
import { validateFiltersAgainstValidationRule } from 'Utils/validationUtils';
import './GDFilterPane.scss';
import moment from 'moment';


class GDFilterPane extends Component {
  constructor(props) {
    super(props);

    this.scrollFilterClose = this.scrollFilterClose.bind(this);

    const showMoreFilters = false; // always start by only showing first 8 filters

    const normalizedValues = normalizeDateFilters(props.filterList, props.currentValues, props.dateFormat);

    /* const currentValuesObj = normalizedValues.reduce((obj, value) => {
      return Object.assign(obj, {
        [value.id]: {
          v1: value.v1,
          v2: value.v2,
          type: value.type,
          error: value.error,
          flag: value.flag,
        },
      });
    }, {}); */

    this.state = {
      selectedCardType: null,
      currentValues: this.props.currentValues,
      filtersCount: this.props.filterList.length,
      selectedItem: this.props.filterList[0],
      showMoreFilters,
      sortedFilterList: this.getCurrentlyShownFilters(props.filterList, showMoreFilters),
      visibleCount: props.filterList.filter((filter) => filter.isVisible).length,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.scrollFilterClose);
  }

  componentWillReceiveProps(nextProps) {
    const newSortedFilterList = this.getCurrentlyShownFilters(nextProps.filterList, this.state.showMoreFilters);

    this.setState({ sortedFilterList: newSortedFilterList });


    const filertWithError = nextProps.currentValues.find((currentFilter) => {
      const r =
        currentFilter.error !== undefined;
      return r;
    },
    );

    if (nextProps.currentValues.length !== this.props.currentValues.length || filertWithError !== undefined) {
      const normalizedValues = normalizeDateFilters(nextProps.filterList, nextProps.currentValues, nextProps.dateFormat);

      const currentValuesObj = normalizedValues.reduce((obj, value) => {
        return Object.assign(obj, {
          [value.id]: {
            v1: value.v1,
            v2: value.v2,
            type: value.type,
            error: value.error,
            flag: value.flag,
          },
        });
      }, []);
      if (nextProps.currentValues !== this.props.currentValues) {
        this.setState({ currentValues: currentValuesObj });
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollFilterClose);
  }

  getCurrentlyShownFilters = (filters, showAll) => {
    const visibleFilters = filters
      .filter((filter) => filter.isVisible)
      .map((filter) => {
        return Object.assign({}, filter, {
          id: filter.reportFilterId,
        });
      });

    return (showAll)
      ? this.sortFilters(visibleFilters)
      : this.sortFilters(visibleFilters).slice(0, 8);
  }

  handleSingleSelection = (value, event) => {
    event.stopPropagation();

    const name = this.findDataAttribute(event.target);
    const field = Number(name);

    if (field) {
      const findFilterList = this.props.filterList.filter((filter) => {
        return filter.reportFilterId === field;
      });
      const foundFilter = findFilterList.shift();

      if (foundFilter) {
        const newSelection = findItem(foundFilter.filterValues, value);
        const newValues = Object.assign({}, this.state.currentValues, {
          [field]: { v1: value },
        });

        if (newSelection) {
          this.setState({ currentValues: newValues });
        }
      }
    } else {
      throw new Error('Could not find numeric filter ID on DOM target, parent or grandparent');
    }
  }

  findDataAttribute(domNode) {
    let name = domNode.dataset.name;

    if (!name) {
      name = domNode.parentElement.dataset.name;
    }

    if (!name) {
      name = domNode.parentElement.parentElement.dataset.name;
    }
    if (!name) {
      name = domNode.id;
    }

    return name;
  }

  handleSelection = (value, event) => {
    event.stopPropagation();

    const name = this.findDataAttribute(event.target);
    const field = Number(name);

    if (field) {
      const findFilterList = this.props.filterList.filter((filter) => {
        return filter.reportFilterId === field;
      });

      const foundFilter = findFilterList.shift();

      if (foundFilter) {
        const newSelection = findItem(foundFilter.filterValues, value);

        const currentMultiSelectValue = (this.state.currentValues[field])
          ? this.state.currentValues[field].v1
          : [];

        const selectedItemsIndex = (currentMultiSelectValue)
          ? currentMultiSelectValue.indexOf(value) : null;

        if (selectedItemsIndex !== -1) {
          currentMultiSelectValue.splice(selectedItemsIndex, 1);
        } else {
          currentMultiSelectValue.push(newSelection.value);
        }


        const newValues = Object.assign({}, this.state.currentValues, {
          [field]: { v1: currentMultiSelectValue },
        });

        if (newSelection) {
          this.setState({
            currentValues: newValues,
          });
        }
      }
    } else {
      throw new Error('Could not find numeric filter ID on DOM target, parent or grandparent');
    }
  }


  sortFilters = (filterList = []) => {
    return filterList.sort((filterA, filterB) => {
      return Number(filterA.displayOrder) - Number(filterB.displayOrder);
    });
  }

  get displayFilterList() {
    return this.state.sortedFilterList.map((filter) => {
      let currentValue;
      if (this.state.currentValues.length) {
        this.state.currentValues.map((cvalue) => {
          for (const key in cvalue) {
            if (key === filter.reportFilterId) {
              currentValue = cvalue[key];
            }
          }
        });
      }

      return (
        <GDFilterElement
          currentValues={currentValue}
          dateFormat={this.props.dateFormat}
          filter={filter}
          handleDualDates={this.handleDualDates}
          handleMonthChange={this.handleMonthChange}
          handleSelection={this.handleSelection}
          handleSingleSelection={this.handleSingleSelection}
          key={filter.id}
          onChange={this.updateFormState}
          onSingleDateChange={this.handleSingleDateChange}
          onRangeChange={this.handleRangeChange}
          translations={this.props.translations}
          id={`${this.props.reportName}_filterElement`}
          language={this.props.language}
          reportKey={this.props.reportKey}
        />
      );
    });
  }


  /**
   * handler called by STRING type filters to update the input value in state
   * @param    {Event} event standard synthetic React event wrapper around DOM event
   * @modifies {state}       updates the matching value in currentValues array in component state
   *
   * @description each value object for a STRING looks like this:
   *                {"id":267, "v1":"last_year", "type":"EXACT"}
   *                where id = filter ID
   *                      v1 = the single value
   *                      type = match type
   */
  updateFormState = (event) => {
    const field = event.target.name;
    const value = event.target.value ? event.target.value.trim() : event.target.value;

    let newValues = this.state.currentValues;
    let valueFound = false;
    let selectedIndex = -1;

    newValues.map((nvalue, index) => {
      for (const key in nvalue) {
        if (key === field) {
          nvalue[key].v1 = value;
          valueFound = true;
          selectedIndex = index;
          break;
        }
      }
    });

    if (value.trim() === '') { newValues.splice(selectedIndex, 1); }

    if (valueFound === false) {
      const newValue = Object.assign({}, {
        [field]: { v1: value },
      });
      newValues.push(newValue);
    }

    this.setState({
      currentValues: newValues,
    });
  }

  handleSingleDateChange = (id, value) => {
    const newValues = this.state.currentValues;
    let valueFound = false;

    newValues.map((nvalue) => {
      for (const key in nvalue) {
        if (key === id) {
          nvalue[key].v1 = moment(value).format('MM/DD/YYYY');
          valueFound = true;
          break;
        }
      }
    });

    if (valueFound === false) {
      const newValue = Object.assign({}, {
        [id]: { v1: moment(value).format('MM/DD/YYYY') },
      });
      newValues.push(newValue);
    }

    this.setState({
      currentValues: newValues,
    });
  }

  /**
   * handler called by Range type filters (CURRENCY, DATE) to update the input value in state
   * @param    {number} id       the database ID of the matching filter
   * @param    {string} selector 'start' for the first value (v1),'end' for second value (v2)
   * @param    {string} value    the value to use
   * @modifies {state}           updates the matching value in currentValues array in component state
   *
   * @description each value object for a STRING looks like this:
   *                {"id":267, "v1":"last_year", "type":"EXACT"}
   *                where id = filter ID
   *                      v1 = the single value
   *                      type = match type
   */
  handleRangeChange = (id, selector, value) => {
    const newValue = value ? value.trim() : value;
    const range = (selector === 'end') ? 'v2' : 'v1';
    const newValues = this.state.currentValues;
    let selectedIndex = -1;
    let isDelete = false;

    let valueFound = false;
    newValues.map((nvalue, index) => {
      for (const key in nvalue) {
        if (key === id) {
          selectedIndex = index;
          nvalue[key].id = id;
          if (range === 'v1') {
            nvalue[key].v1 = newValue;
            valueFound = true;
          } else if (range === 'v2') {
            nvalue[key].v2 = newValue;
            valueFound = true;
          }
          if ((nvalue[key].v1 === '' && nvalue[key].v2 === '') || (nvalue[key].v1 === null && nvalue[key].v2 === null)) {
            isDelete = true;
          }
          break;
        }
      }
    });

    if (valueFound === false) {
      const newValue1 = Object.assign({}, {
        [id]: { [range]: newValue },
      });
      newValues.push(newValue1);
    }

    if (isDelete) { newValues.splice(selectedIndex, 1); }

    this.setState({
      currentValues: newValues,
    });
  }

  handleDualDates = (id, dualValues) => {
    this.props.deleteAlertPrefsByAlertkey(types.REPORT_VALIDATION);
    // find or create filter values obj
    let targetValues = (this.state.currentValues[id]) || {};
    let selectedIndex = -1;
    let isDelete = false;
    let valueFound = false;
    let newType = '';

    let newValues = this.state.currentValues;

    newValues.map((nvalue,index) => {
      for(const key in nvalue){
        if(key === id){
          nvalue[key].id = id;
          selectedIndex = index;
          nvalue[key].v1 = dualValues.startDate;
          nvalue[key].v2 = dualValues.endDate;
          if (dualValues.startDate && dualValues.endDate) {
            nvalue[key].type = 'BETWEEN';
            newType = 'BETWEEN';
          } else if (dualValues.startDate) {
            nvalue[key].type = 'STARTS_WITH';
            newType = 'STARTS_WITH';
          } else if (dualValues.endDate) {
            nvalue[key].type = 'ENDS_WITH';
            newType = 'ENDS_WITH';
          } else {
            nvalue[key].type = 'DELETE';
            newType = 'DELETE';
          }
          nvalue[key].error = '';
          nvalue[key].flag = false;
          valueFound = true;
          if ((nvalue[key].v1 === '' && nvalue[key].v2 === '') || (nvalue[key].v1 === null && nvalue[key].v2 === null)) {
            isDelete = true;
          }
          break;
        }
      }

    });

    if (valueFound === false) {
      const newValue1 = Object.assign({}, {
        [id]: { 'v1': dualValues.startDate, 'v2': dualValues.endDate, 'type': newType, 'error': '', 'flag': true },
      });
      newValues.push(newValue1);
    }

    if (isDelete) { newValues.splice(selectedIndex, 1); }

    /* // copy current values
    const newValues = Object.assign({}, this.state.currentValues, {
      [id]: targetValues,
    }); */

    // decide type
    
    const currentCalenderValues = [{ id, v1: dualValues.startDate, v2: dualValues.endDate, type: targetValues.type }];
    validateFiltersAgainstValidationRule(this.props.filterList, currentCalenderValues,
      this.props.dateFormat).then((currentValues) => {
        const modfiedObject = currentValues.find((currentValue) => {
          return id === currentValue.id;
        });
        if (modfiedObject && modfiedObject.error) {
          Object.assign(targetValues, {
            error: modfiedObject.error,
            flag: modfiedObject.flag,
          });
          this.props.setAlertPrefs([{
            showAlert: true,
            msgAlertType: 'danger',
            displayText: targetValues.error,
            alertKey: types.REPORT_VALIDATION,
          }]);
        }
        this.setState({
          currentValues: newValues,
        });
      });
  }


  handleMonthChange = (id, value) => {
    const targetValues = (this.state.currentValues[id]) || {};
    targetValues.v1 = value;

    // copy current values
    const newValues = Object.assign({}, this.state.currentValues, {
      [id]: targetValues,
    });

    this.setState({
      currentValues: newValues,
    });
  }

  toggleFilters = () => {
    const newShowStatus = !this.state.showMoreFilters;
    const newSortedFilterList = this.getCurrentlyShownFilters(this.props.filterList, newShowStatus);
    this.setState({
      showMoreFilters: newShowStatus,
      sortedFilterList: newSortedFilterList,
    });
  }

  clearFilters = () => {
    this.setState({
      currentValues: [],
    });
    this.props.resetValues();
  }

  applyFilters = () => {
    this.props.applyFilters(this.state.currentValues);
    if (this.state.showMoreFilters) {
      this.toggleFilters();
    }
  }

  scrollFilterClose() {
    const filterElement = document.getElementById('filter-pane');
    const trigger = filterElement.getBoundingClientRect().top + filterElement.offsetHeight;

    if (trigger <= 140) {
      this.props.resetScrollPos();
      this.props.closeFilterPane();
    }
  }

  render() {
    const wrapperClass = classnames('gd-filter-pane', {
      [this.props.extraClass]: this.props.extraClass,
      hidden: !this.props.isVisible,
      show: this.props.isVisible,
      push: this.props.pushFilterPane,
    });

    const filterPaneContentClass = classnames('gd-filter-pane__content', {
      more: this.state.showMoreFilters,
      base: !this.state.showMoreFilters,
    });

    const { reportName, translations } = this.props;

    const moreLessText = (this.state.showMoreFilters)
      ? 'Less'
      : 'More';

    return (
      <div id="filter-pane" className={wrapperClass}>
        <div className={filterPaneContentClass}>
          <div className="filter-input-container">
            {this.displayFilterList}
          </div>
        </div>

        {this.state.visibleCount > 8 ?
          <div className="toggle-breakline">
            <PrimaryButton
              action={this.toggleFilters}
              extraClass="btn-breakline"
              iconDirection="right"
              icon={this.state.showMoreFilters ? TriangleUp : TriangleDown}
              id={`${reportName}_btn_${moreLessText}`}
            >
              {moreLessText}
            </PrimaryButton>
          </div>
          : ''
        }

        <div className="gd-filter-pane__footer">
          <Button
            action={this.clearFilters}
            extraClass="clear-filters"
            category="link-inline"
            id={`${reportName}_btn_clear`}
          >
            {translations.clear}
          </Button>
          <div className="gd-filter-pane__footer-right">
            <Button
              action={this.props.closeFilterPane}
              extraClass="gd-filter-pane__close-button"
              id={`${reportName}_btn_cancel`}
            >
              {translations.cancel}
            </Button>
            <PrimaryButton
              action={this.applyFilters}
              extraClass="gd-filter-pane__apply-button"
              id={`${reportName}_btn_apply`}
              currentValues={this.state.currentValues}
            >
              {translations.apply}
            </PrimaryButton>
          </div>
        </div>
      </div>
    );
  }
}

GDFilterPane.propTypes = {
  applyFilters: PropTypes.func.isRequired,
  closeFilterPane: PropTypes.func.isRequired,
  currentValues: PropTypes.array,
  dateFormat: PropTypes.string.isRequired,
  extraClass: PropTypes.string,
  filterList: PropTypes.array.isRequired,
  isVisible: PropTypes.bool,
  pushFilterPane: PropTypes.bool,
  reportName: PropTypes.string,
  reportKey: PropTypes.string,
  translations: PropTypes.object,
  language: PropTypes.string,
  setAlertPrefs: PropTypes.func,
  deleteAlertPrefsByAlertkey: PropTypes.func,
  callOnBoardContainer: PropTypes.bool,
  resetScrollPos: PropTypes.func.isRequired,
  resetValues: PropTypes.func.isRequired,
};

GDFilterPane.defaultProps = {
  currentValues: [],
  resetScrollPos: () => { },
  setAlertPrefs: () => { },
  deleteAlertPrefsByAlertkey: () => { },
  extraClass: '',
  filterList: [],
  isVisible: false,
  pushFilterPane: false,
  reportName: '',
  reportKey: '',
  translations: {
    apply: 'Apply',
    cancel: 'Cancel',
    clear: 'Reset',
  },
  callOnBoardContainer: true,
};

export default GDFilterPane;
